// Get workflows
export const getAllWorkflows = (params) => ({
  type: 'GET_ALL_WORKFLOWS',
  payload: params,
});

export const setAllWorkflows = (payload) => ({
  payload,
  type: 'SET_ALL_WORKFLOWS',
});

// Single workflow
export const getSingleWorkflow = (payload) => ({
  payload,
  type: 'GET_SINGLE_WORKFLOW',
});

export const setSingleWorkflow = (payload) => ({
  payload,
  type: 'SET_SINGLE_WORKFLOW',
});

// Create workflow
export const createWorkflow = ({ data, successCallback, failCallback }) => ({
  type: 'CREATE_WORKFLOW',
  payload: { data, successCallback, failCallback },
});

// Update workflow
export const updateWorkflow = (id, data, successCallback, failCallback) => ({
  type: 'UPDATE_WORKFLOW',
  payload: { id, data, successCallback, failCallback }
});

// Delete workflow
export const deleteWorkflow = (payload) => ({
  payload,
  type: 'DELETE_WORKFLOW',
});

// Batch delete workflows
export const batchDeleteWorkflows = (workflowIds) => ({
  type: 'BATCH_DELETE_WORKFLOWS',
  payload: workflowIds,
});

// Clone workflow
export const cloneWorkflow = (payload) => ({
  payload,
  type: 'CLONE_WORKFLOW',
});

// Execute workflow
export const executeWorkflow = ({ id, input, successCallback, failCallback }) => ({
  type: 'EXECUTE_WORKFLOW',
  payload: { id, input, successCallback, failCallback },
});

// Get workflow executions
export const getWorkflowExecutions = (payload) => ({
  payload,
  type: 'GET_WORKFLOW_EXECUTIONS',
});

export const setWorkflowExecutions = (payload) => ({
  payload,
  type: 'SET_WORKFLOW_EXECUTIONS',
});

// Get execution details
export const getExecutionDetails = (payload) => ({
  payload,
  type: 'GET_EXECUTION_DETAILS',
});

export const setExecutionDetails = (payload) => ({
  payload,
  type: 'SET_EXECUTION_DETAILS',
});

// Get workflow templates
export const getAllWorkflowTemplates = () => ({
  type: 'GET_ALL_WORKFLOW_TEMPLATES',
});

export const setAllWorkflowTemplates = (payload) => ({
  payload,
  type: 'SET_ALL_WORKFLOW_TEMPLATES',
});

// Create from template
export const createFromTemplate = ({ templateId, data, successCallback, failCallback }) => ({
  type: 'CREATE_FROM_TEMPLATE',
  payload: { templateId, data, successCallback, failCallback },
});

// UI State
export const setWorkflowFilters = (payload) => ({
  payload,
  type: 'SET_WORKFLOW_FILTERS',
});

export const setSelectedNode = (payload) => ({
  payload,
  type: 'SET_SELECTED_NODE',
});

export const setSelectedWorkflow = (payload) => ({
  payload,
  type: 'SET_SELECTED_WORKFLOW',
});

export const setWorkflowNodes = (payload) => ({
  payload,
  type: 'SET_WORKFLOW_NODES',
});

export const setWorkflowEdges = (payload) => ({
  payload,
  type: 'SET_WORKFLOW_EDGES',
});

export const setWorkflowBuilderModal = (payload) => ({
  payload,
  type: 'SET_WORKFLOW_BUILDER_MODAL',
});

export const setWorkflowExecutionModal = (payload) => ({
  payload,
  type: 'SET_WORKFLOW_EXECUTION_MODAL',
});

// Version Management Actions
export const getWorkflowVersions = (payload) => ({
  payload,
  type: 'GET_WORKFLOW_VERSIONS',
});

export const setWorkflowVersions = (payload) => ({
  payload,
  type: 'SET_WORKFLOW_VERSIONS',
});

export const createWorkflowVersion = (payload) => ({
  payload,
  type: 'CREATE_WORKFLOW_VERSION',
});

export const restoreWorkflowVersion = (payload) => ({
  payload,
  type: 'RESTORE_WORKFLOW_VERSION',
});

export const compareWorkflowVersions = (payload) => ({
  payload,
  type: 'COMPARE_WORKFLOW_VERSIONS',
});

export const setVersionComparison = (payload) => ({
  payload,
  type: 'SET_VERSION_COMPARISON',
});

// Scheduling Actions
export const getWorkflowSchedules = (payload) => ({
  payload,
  type: 'GET_WORKFLOW_SCHEDULES',
});

export const setWorkflowSchedules = (payload) => ({
  payload,
  type: 'SET_WORKFLOW_SCHEDULES',
});

export const createWorkflowSchedule = (payload) => ({
  payload,
  type: 'CREATE_WORKFLOW_SCHEDULE',
});

export const updateWorkflowSchedule = (payload) => ({
  payload,
  type: 'UPDATE_WORKFLOW_SCHEDULE',
});

export const deleteWorkflowSchedule = (payload) => ({
  payload,
  type: 'DELETE_WORKFLOW_SCHEDULE',
});

export const pauseWorkflowSchedule = (payload) => ({
  payload,
  type: 'PAUSE_WORKFLOW_SCHEDULE',
});

export const resumeWorkflowSchedule = (payload) => ({
  payload,
  type: 'RESUME_WORKFLOW_SCHEDULE',
});

// Analytics Actions
export const getWorkflowAnalytics = (payload) => ({
  payload,
  type: 'GET_WORKFLOW_ANALYTICS',
});

export const setWorkflowAnalytics = (payload) => ({
  payload,
  type: 'SET_WORKFLOW_ANALYTICS',
});

export const getWorkspaceAnalytics = (payload) => ({
  payload,
  type: 'GET_WORKSPACE_ANALYTICS',
});

export const setWorkspaceAnalytics = (payload) => ({
  payload,
  type: 'SET_WORKSPACE_ANALYTICS',
});

// LangGraph Actions
export const getLangGraphNodeTypes = () => ({
  type: 'GET_LANGGRAPH_NODE_TYPES',
});

export const setLangGraphNodeTypes = (payload) => ({
  payload,
  type: 'SET_LANGGRAPH_NODE_TYPES',
});

export const getLangGraphNodeMetadata = () => ({
  type: 'GET_LANGGRAPH_NODE_METADATA',
});

export const setLangGraphNodeMetadata = (payload) => ({
  payload,
  type: 'SET_LANGGRAPH_NODE_METADATA',
});

export const validateLangGraphNode = ({ nodeConfig, successCallback, failCallback }) => ({
  type: 'VALIDATE_LANGGRAPH_NODE',
  payload: { nodeConfig, successCallback, failCallback },
});

export const executeLangGraphWorkflow = ({ workflowId, input, options, successCallback, failCallback }) => ({
  type: 'EXECUTE_LANGGRAPH_WORKFLOW',
  payload: { workflowId, input, options, successCallback, failCallback },
});

export const testLangGraphWorkflow = ({ workflowId, input, options, successCallback, failCallback }) => ({
  type: 'TEST_LANGGRAPH_WORKFLOW',
  payload: { workflowId, input, options, successCallback, failCallback },
});

export const validateLangGraphWorkflow = ({ workflowId, successCallback, failCallback }) => ({
  type: 'VALIDATE_LANGGRAPH_WORKFLOW',
  payload: { workflowId, successCallback, failCallback },
});

export const getLangGraphSystemMetrics = () => ({
  type: 'GET_LANGGRAPH_SYSTEM_METRICS',
});

export const setSystemMetrics = (payload) => ({
  payload,
  type: 'SET_SYSTEM_METRICS',
});

// Execution Management Actions
export const resumeExecution = ({ executionId, input, options, successCallback, failCallback }) => ({
  type: 'RESUME_EXECUTION',
  payload: { executionId, input, options, successCallback, failCallback },
});

export const cancelExecution = ({ executionId, reason, successCallback, failCallback }) => ({
  type: 'CANCEL_EXECUTION',
  payload: { executionId, reason, successCallback, failCallback },
});

export const getCheckpoints = (executionId) => ({
  type: 'GET_CHECKPOINTS',
  payload: executionId,
});

export const setCheckpoints = (payload) => ({
  payload,
  type: 'SET_CHECKPOINTS',
});

// Import/Export Actions
export const importWorkflow = ({ workflowData, successCallback, failCallback }) => ({
  type: 'IMPORT_WORKFLOW',
  payload: { workflowData, successCallback, failCallback },
});

export const exportWorkflow = ({ workflowId, format, successCallback, failCallback }) => ({
  type: 'EXPORT_WORKFLOW',
  payload: { workflowId, format, successCallback, failCallback },
});

// Batch Operations
export const batchExecute = ({ executions, options, successCallback, failCallback }) => ({
  type: 'BATCH_EXECUTE',
  payload: { executions, options, successCallback, failCallback },
});

export const batchValidate = ({ workflowIds, successCallback, failCallback }) => ({
  type: 'BATCH_VALIDATE',
  payload: { workflowIds, successCallback, failCallback },
});

// Template-related actions
export const listSystemTemplates = (params) => ({
  type: 'LIST_SYSTEM_TEMPLATES',
  payload: params,
});

export const getRequiredConnections = (workflowId) => ({
  type: 'GET_REQUIRED_CONNECTIONS',
  payload: { workflowId },
});

// Note: cloneWorkflow is already defined above on line 48

// CRM Tag Operations
export const getContactTags = ({ contactId, successCallback, failCallback }) => ({
  type: 'GET_CONTACT_TAGS',
  payload: { contactId, successCallback, failCallback },
});

export const setContactTags = (payload) => ({
  payload,
  type: 'SET_CONTACT_TAGS',
});

export const clearContactTags = () => ({
  type: 'CLEAR_CONTACT_TAGS',
});

